import React from 'react';
import styled from 'styled-components';
import { Search } from '@carbon/icons-react';

const SearchContainer = styled.div`
  position: relative;
  max-width: 500px;
  margin: 2rem auto;
`;

const SearchInput = styled.input`
  padding: 12px 16px 12px 3rem;
  width: 100%;
  border: 2px solid #e2e8f0;
  border-radius: 8px;
  font-size: 16px;
  outline: none;
  transition: border-color 0.2s ease;

  &:focus {
    border-color: #007bff;
  }

  &::placeholder {
    color: #a0aec0;
  }
`;

const SearchIcon = styled(Search)`
  position: absolute;
  left: 1rem;
  top: 50%;
  transform: translateY(-50%);
  color: #666;
  z-index: 1;
`;

const SearchSpinner = styled.div`
  position: absolute;
  left: 1rem;
  top: 50%;
  transform: translateY(-50%);
  width: 20px;
  height: 20px;
  border: 2px solid #f3f3f3;
  border-top: 2px solid #007bff;
  border-radius: 50%;
  animation: spin 1s linear infinite;
  z-index: 1;

  @keyframes spin {
    0% {
      transform: translateY(-50%) rotate(0deg);
    }
    100% {
      transform: translateY(-50%) rotate(360deg);
    }
  }
`;

export interface SearchBarProps {
  value: string;
  onChange: (value: string) => void;
  isLoading?: boolean;
  placeholder?: string;
}

export const SearchBar: React.FC<SearchBarProps> = ({
  value,
  onChange,
  isLoading = false,
  placeholder = 'Search clubs by name, country...',
}) => {
  return (
    <SearchContainer>
      {isLoading ? <SearchSpinner /> : <SearchIcon size={20} />}
      <SearchInput
        placeholder={placeholder}
        value={value}
        onChange={(e: React.ChangeEvent<HTMLInputElement>) => onChange(e.target.value)}
      />
    </SearchContainer>
  );
};
